import { Box } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { FormNumericField, FormTextField } from "@/components/UiKit"
import type { SoftReceiveFormValues } from "@/screens/WarehouseReceiving/schemas"

export const SoftReceiveForm: FC = () => {
  const { control } = useFormContext<SoftReceiveFormValues>()

  return (
    <Box className='flex flex-col gap-6'>
      <FormTextField
        name='holdArea'
        control={control}
        label='Destination'
        required
        disabled
        data-testid='hold-area-input'
      />
      <FormNumericField
        name='estimatedPalletsCount'
        control={control}
        label='Estimated Pallets'
        placeholder='Enter estimated pallets'
        allowNegative={false}
        decimalScale={2}
        data-testid='estimated-pallets-input'
      />
      <FormNumericField
        name='deliveredPalletsCount'
        control={control}
        label='Pallet Qty Delivered'
        required
        placeholder='Enter pallet quantity delivered'
        allowNegative={false}
        decimalScale={2}
        data-testid='pallet-qty-delivered-input'
      />
      <FormNumericField
        name='spacesUsed'
        control={control}
        label='Spaces Used'
        placeholder='Enter spaces used'
        allowNegative={false}
        decimalScale={0}
        data-testid='spaces-used-input'
      />
      <FormTextField
        name='comment'
        control={control}
        label='Comment'
        multiline
        rows={4}
        placeholder='Enter comments'
        data-testid='comments-input'
      />
    </Box>
  )
}
